var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.66699 17.3333H10.4403L13.3337 20.2267V11.7733L10.4403 14.6667H6.66699V17.3333Z",
    fill: "#00140B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6663L9.33301 20.0003H4V12.0003H9.33301L16 5.33333V26.6663Z",
    fill: "#00140B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 10.6267V21.36C20.6403 20.3867 22.0003 18.36 22.0003 16C22.0003 13.64 20.6403 11.6133 18.667 10.6267Z",
    fill: "#00140B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 4.30667V7.05333C22.5203 8.2 25.3337 11.7733 25.3337 16C25.3337 20.2267 22.5203 23.8 18.667 24.9467V27.6933C24.0137 26.48 28.0003 21.7067 28.0003 16C28.0003 10.2933 24.0137 5.52 18.667 4.30667Z",
    fill: "#00140B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.e4f01e4641c2e841a77993d436eac6ad.svg";
export { ForwardRef as ReactComponent };